import React, { useEffect, useState } from 'react'
import { ArrowBackIos, WidgetsOutlined } from '@material-ui/icons'
import { Button, Card, Col, Container, Form, Row } from 'react-bootstrap'
import { ErrorMessage, Formik } from 'formik'
import ReactMultiSelect from '@kenshooui/react-multi-select'
import Loading from 'components/Loading'
import InputMoney from 'helpers/Currency/InputMoney'
import { currencyReverse } from 'helpers/Currency'
import * as yup from "yup";
import ResalesRequestService from 'services/resales-request'
import { maskDocument } from 'helpers/document'
import DeductionRequestService from 'services/deduction-request'
import Alert from 'helpers/alert'
import Swal from 'sweetalert2'
import { useHistory } from 'react-router-dom'
import { useCompany } from 'models'
import Unauthorized from 'components/Unauthorized'

export default function () {
  const history = useHistory()
  const { company } = useCompany()
  const [companies, setCompanies] = useState([])
  const [error] = useState(!company)

  useEffect(() => {
    //getCompanies()
  }, [])

  function getCompanies() {
    ResalesRequestService.getForSelect()
      .then(res => {
        const items = res.data.map(item => {
          return {
            id: item.id,
            label: `${!item.alias ? item.name : item.alias} - ${maskDocument(item.document)}`
          }
        })
        setCompanies(items)
      })
  }

  const validationSchema = yup.object({
    value: yup.number()
      .test(
        "is-more-then-zero",
        "O valor deve ser maior que 0",
        (val) => {
          return val > 0
        }
      )
      .required("Valor Obrigatório"),
    observation: yup.string().required("Tipo Obrigatório"),
    companies: yup.array().min(1, "Pelo menos uma empresa deve ser selecionada"),
    comments: yup.string().notRequired()
  })

  function _handleSubmit(values) {
    values.companies = values.companies.map(c => c.id)
    DeductionRequestService.store(values)
      .then(() => {
        Alert.success("Cadastro feito!")
          .then((result) => {
            if (result.dismiss === Swal.DismissReason.timer) {
              history.push('/elite/scancash/deductions')
            }
          })
      })
  }

  if(error){
    return <Unauthorized/>;
  }

  return (
    <Container>
      <Row className="mt-4">
        <Button variant="link" className="link-back" onClick={() => history.goBack()}>
          <ArrowBackIos className="icon-title icon-back" />
          <h6 className="font-13 mt-3">Voltar</h6>
        </Button>
      </Row>
      <Row className="mt-3 align-items-end justify-content-between">
        <Col xs="auto" className="d-flex">
          <WidgetsOutlined className="icon-title" />
          <h5 className="title-dashboard">Adicionar Dedução</h5>
        </Col>
      </Row>
      <Row>
        <Card.Body className="card-dashboard shadow bg-white rounded m-2 col-12">
          <Formik
            validationSchema={validationSchema}
            initialValues={{
              companies: company ? [{ id: company.id, label: company.alias ?? company.name }] : [],
              value: "",
              observation: "",
              comments: ""
            }}
            onSubmit={_handleSubmit}
          >
            {({ handleSubmit, setFieldValue, errors, values }) => {
              return (
                <Form onSubmit={handleSubmit}>
                  <Row>
                    <Col md={6}>
                      <Form.Group>
                        <Form.Label>Valor:</Form.Label>
                        <InputMoney
                          placeholder="R$ 0,00"
                          value={values.value}
                          name="value"
                          size=""
                          onChange={(ev) => {
                            setFieldValue("value", currencyReverse(ev.target.value))
                          }}
                        />
                        <ErrorMessage component="span" className='text-danger' name="value" />
                      </Form.Group>
                    </Col>
                    <Col md={6}>
                      <Form.Group>
                        <Form.Label>Tipo:</Form.Label>
                        <Form.Control
                          as="select"
                          name='observation'
                          onChange={(ev) => {
                            setFieldValue("observation", ev.target.value)
                          }}
                        >
                          <option value="">Selecione o Tipo</option>
                          <option>Evento EPC</option>
                          <option>Saldo negativo ano anterior</option>
                        </Form.Control>
                        <ErrorMessage component="span" className='text-danger' name="type" />
                      </Form.Group>
                    </Col>
                    <Col md={12}>
                      <Form.Group>
                        <Form.Label>Comentários:</Form.Label>
                        <Form.Control
                          as="textarea"
                          rows={6}
                          onChange={(ev) => {
                            setFieldValue("comments", ev.target.value)
                          }}
                        />
                      </Form.Group>
                    </Col>
                    <Col md={12} className='mb-4'>
                      <Form.Group>
                        <Form.Label>Revenda(s):</Form.Label>
                        {company ? (
                          <Form.Control
                            as="input"
                            disabled
                            value={values.companies[0].label}
                          />
                        ) : (
                          <ReactMultiSelect
                            name="companies"
                            loaderRenderer={() => (
                              <div style={{ margin: 'auto auto' }}>
                                <Loading page />
                              </div>
                            )}
                            messages={{
                              searchPlaceholder: "Procurar...",
                              noItemsMessage: "Sem Revendas...",
                              noneSelectedMessage: "Nada Selecionado",
                              selectedMessage: "Selecionado(s)",
                              selectAllMessage: "Selecionar Todas",
                              clearAllMessage: "Limpar Tudo"
                            }}
                            selectedItems={values.companies}
                            items={companies}
                            onChange={(selected) => {
                              setFieldValue("companies", selected)
                            }}
                          />
                        )}
                      </Form.Group>
                      <ErrorMessage component="span" className='text-danger' name="companies" />
                    </Col>
                    <Col md="12">
                      <Button type="submit">Salvar Dados</Button>
                    </Col>
                  </Row>
                </Form>
              )
            }}
          </Formik>
        </Card.Body>
      </Row>
    </Container>
  )
}